<template>
    <div>
        <breadcrumb :routerList="[{to:'/loud/loud',title:'信息漏斗'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <el-form-item label="节点">
                            <brselect category="xinxi_jiedian"
                                      :v="formInline.statusR"
                                      :multiple="true"
                                      clearable
                                      style="width:3.7rem"
                                      v-model="formInline.statusR">
                            </brselect>
                        </el-form-item>
                        <el-form-item label="创建日期">
                            <el-date-picker
                                    :clearable="true"
                                    v-model="formInline.cdate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="--日期--"
                                    style="width:1.6rem">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item v-if="showArea" label="区域">
                            <brselect
                                    style="width:1.2rem"
                                    category="YLRegion"
                                    :v="formInline.area"
                                    v-model="formInline.area"
                                    clearable placeholder="--请选择--">
                            </brselect>
                        </el-form-item>
                        <el-form-item label="产品大类">
                            <brselect style="width:1.5rem" category="product_level" :v="formInline.productType"
                                      v-model="formInline.productType"
                                      clearable placeholder="--请选择--"></brselect>
                        </el-form-item>
                        <!--                        <el-form-item label="金额总计">-->
                        <!--                            <el-input style="width:2rem" v-model="formInline.totalValue" placeholder="请输入查询金额" clearable></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item class="h-formBtnOut">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn" @click="resetData"
                                       style="background-color:white;color:black;border:1px solid #d1d1d1">重置
                            </el-button>
                        </el-form-item>
                        <el-form-item label="" class="h-elformWrap-2" style="margin-bottom: 0.4rem;">
                            <el-switch
                                    @click="chooseModify"
                                    v-model="moreCondition"
                                    active-text="更多条件"
                                    inactive-text="">
                            </el-switch>
                        </el-form-item>
                        <div class="h-pieceCon2" v-if="this.moreCondition">
                            <el-form-item label="报单日期" style="margin-left:0.4rem">
                                <el-date-picker
                                        :clearable="true"
                                        v-model="formInline.expectConvertDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="--日期--"
                                        style="width:2rem">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="预计投标日期" style="margin-left:0.3rem">
                                <el-date-picker
                                        :clearable="true"
                                        v-model="formInline.bidConvDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="--日期--"
                                        style="width:2rem">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="预计成单时间" style="margin-left:0.3rem">
                                <el-date-picker
                                        :clearable="true"
                                        v-model="formInline.expConvDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="--日期--"
                                        style="width:2rem">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="中标概率" style="margin-left:0.6rem">
                                <el-select v-model="formInline.bidPercentage" placeholder="请选择"
                                           :clearable="true" filterable style="width:2rem">
                                    <el-option label="0%" value="0%"></el-option>
                                    <el-option label="30%" value="30%"></el-option>
                                    <el-option label="50%" value="50%"></el-option>
                                    <el-option label="80%" value="80%"></el-option>
                                    <el-option label="100%" value="100%"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="机会大类" style="margin-left:0.4rem">
                                <brselect
                                        style="width:2rem"
                                        category="chance_type"
                                        :v="formInline.chance"
                                        v-model="formInline.chance"
                                        clearable
                                        placeholder="--请选择--">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="渠道" style="margin-left:1.1rem">
                                <brselect
                                        style="width:2rem;"
                                        category="sales_region"
                                        :v="formInline.customerChannel"
                                        v-model="formInline.customerChannel"
                                        clearable
                                        placeholder="--请选择--">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="用户单位" style="margin-left:0.7rem">
                                <el-input
                                        v-model="formInline.customerName"
                                        placeholder="请输入"
                                        style="width:2rem">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="跟单商类别" style="margin-left:0.4rem">
                                <brselect
                                        style="width:2rem"
                                        category="gendanshang"
                                        :v="formInline.merchandiser"
                                        v-model="formInline.merchandiser"
                                        clearable
                                        placeholder="--请选择--">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="备注" style="margin-left:0.8rem">
                                <el-input
                                        v-model="formInline.remark"
                                        placeholder="请输入"
                                        style="width:2rem">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="丢/中标品牌" style="margin-left:0.4rem">
                                <el-input
                                        v-model="formInline.dbBrand"
                                        placeholder="请输入"
                                        style="width:2rem">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="是否预算" style="margin-left:0.7rem">
                                <brselect
                                        style="width:2rem"
                                        category="shifou_keyong"
                                        :v="formInline.doBudget"
                                        v-model="formInline.doBudget"
                                        clearable placeholder="--请选择--">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="是否城市网触点">
                                <brselect
                                        style="width:2rem"
                                        category="chengshi_wang"
                                        :v="formInline.whetherContactor"
                                        v-model="formInline.whetherContactor"
                                        clearable
                                        placeholder="--请选择--">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="是否审批" style="margin-left:0.4rem">
                                <brselect
                                        style="width:2rem"
                                        category="shifou_keyong"
                                        :v="formInline.doApproval"
                                        v-model="formInline.doApproval"
                                        clearable
                                        placeholder="--请选择--">
                                </brselect>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn smTable" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
                            @cell-mouse-enter="tablemouseenter"
                            @cell-mouse-leave="tablemouseleave"
                            style="width: 100%">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="statusR"
                                width="210"
                                label="节点"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode == scope.row.cucode"
                                          category="xinxi_jiedian" :v="scope.row.statusR" v-model="scope.row.statusR"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          class="h-tableInput"/>
                                <!--  改颜色用的    :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"-->
                                <dictname v-else category="xinxi_jiedian" :v="scope.row.statusR"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                width="250"
                                label="创建时间"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.cdate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="expectConvertDate"
                                width="180"
                                label="报单日期"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.expectConvertDate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="bidConvDate"
                                width="180"
                                label="预计投标日期"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.bidConvDate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="bidPercentage"
                                label="中标概率"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.bidPercentage}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="expConvDate"
                                width="180"
                                label="预计成单日期"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.expConvDate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                width="150"
                                label="区域"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLRegion" :v="scope.row.area"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                width="180"
                                label="责任人要至跟单人"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="_user.usercode ==  scope.row.cucode"
                                          v-model="scope.row.cuname"
                                          placeholder="责任人要至跟单人"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else
                                     :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.cuname}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chamberlain"
                                width="180"
                                label="小管家"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="_user.usercode ==  scope.row.cucode"
                                          v-model="scope.row.chamberlain"
                                          placeholder="小管家"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else
                                     :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.chamberlain}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="partner"
                                width="200"
                                label="合伙人(客户或者个人)"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-if="_user.usercode ==  scope.row.cucode"
                                          v-model="scope.row.partner"
                                          placeholder="合伙人(客户或者个人)"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          class="h-tableInput"></el-input>
                                <div v-else
                                     :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                    {{scope.row.partner}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="chance"
                                width="210"
                                label="机会大类"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode ==  scope.row.cucode"
                                          category="chance_type" :v="scope.row.chance" v-model="scope.row.chance"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="chance_type" :v="scope.row.chance"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="customerChannel"
                                width="210"
                                label="渠道"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <brselect v-if="_user.usercode ==  scope.row.cucode"
                                          category="sales_region" :v="scope.row.customerChannel"
                                          v-model="scope.row.customerChannel"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          class="h-tableInput"/>
                                <dictname v-else category="sales_region" :v="scope.row.customerChannel"
                                          :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                          style="display:inline-block;width: 100%;height:100%;"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="用户信息" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="customerName"
                                    width="200"
                                    label="用户单位"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.customerName}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="deptName"
                                    width="120"
                                    label="部门/科室"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.deptName}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="chargePerson"
                                    width="120"
                                    label="负责人"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.chargePerson}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="phone"
                                    width="120"
                                    label="电话"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.phone}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="跟单商信息" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="merchandiser"
                                    width="150"
                                    label="跟单商类别"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <dictname category="gendanshang"  :v="scope.row.merchandiser"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              style="display:inline-block;width: 100%;height:100%;"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="corporateName"
                                    width="180"
                                    :show-overflow-tooltip="true"
                                    label="公司名称(直单写海尔)">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.corporateName}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="merchChargePerson"
                                    width="150"
                                    label="负责人"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.merchChargePerson}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="chargePersonPhone"
                                    width="150"
                                    label="电话"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.chargePersonPhone}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="产品信息"
                                         :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="productType"
                                    width="120"
                                    label="产品大类"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <dictname category="product_level"  :v="scope.row.productType"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              style="display:inline-block;width: 100%;height:100%;"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="productModel"
                                    width="120"
                                    label="产品型号"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.productModel}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="num"
                                    width="120"
                                    label="数量"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.num}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="price"
                                    width="120"
                                    label="价格(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.price}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="totalValue"
                                    width="120"
                                    label="合计(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.totalValue}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="备注" :show-overflow-tooltip="true" style="">
                            <el-table-column
                                    prop="remark"
                                    label="招标网挂网信息-在此列注明（招标网信息补录）"
                                    width="380"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input
                                            v-if="_user.usercode ==  scope.row.cucode"
                                            v-model="scope.row.remark"
                                            placeholder="备注"
                                            :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                            class="h-tableInput">
                                    </el-input>
                                    <div v-else
                                         :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.remark}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="丢标" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="dbBrand"
                                    width="150"
                                    label="中标品牌"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode"
                                              v-model="scope.row.dbBrand"
                                              placeholder="中标品牌"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else
                                         :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.dbBrand}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dbCompany"
                                    width="150"
                                    label="中标公司"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode"
                                              v-model="scope.row.dbCompany"
                                              placeholder="中标公司"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else
                                         :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.dbCompany}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dbTotalValue"
                                    width="150"
                                    label="中/丢标总额(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode"
                                              v-model="scope.row.dbTotalValue" placeholder="0"
                                              class="h-tableInput"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                                    <div v-else
                                         :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.dbTotalValue}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="dbReason"
                                    width="150"
                                    label="丢标原因"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode"
                                              v-model="scope.row.dbReason"
                                              placeholder="丢标原因"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              class="h-tableInput"></el-input>
                                    <div v-else
                                         :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.dbReason}}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="U血液必填项" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="doBudget"
                                    width="150"
                                    label="是否做了预算"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <brselect v-if="_user.usercode ==  scope.row.cucode"
                                              category="shifou_keyong" :v="scope.row.doBudget"
                                              v-model="scope.row.doBudget"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              class="h-tableInput"/>
                                    <dictname v-else category="shifou_keyong" :v="scope.row.doBudget"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              style="display:inline-block;width: 100%;height:100%;"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="whetherContactor"
                                    width="150"
                                    label="是否城市网触点"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <brselect v-if="_user.usercode ==  scope.row.cucode"
                                              category="chengshi_wang" :v="scope.row.whetherContactor"
                                              v-model="scope.row.whetherContactor"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              class="h-tableInput"/>
                                    <dictname v-else category="chengshi_wang" :v="scope.row.whetherContactor"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              style="display:inline-block;width: 100%;height:100%;"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="budgetAmount"
                                    width="150"
                                    label="预算金额(万元)"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input v-if="_user.usercode ==  scope.row.cucode"
                                              v-model="scope.row.budgetAmount" placeholder="0"
                                              class="h-tableInput"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                                    <div v-else
                                         :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']">
                                        {{scope.row.budgetAmount}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="doApproval"
                                    width="150"
                                    label="是否审批">
                                <template slot-scope="scope">
                                    <brselect v-if="_user.usercode ==  scope.row.cucode"
                                              category="shifou_keyong" :v="scope.row.doApproval"
                                              v-model="scope.row.doApproval"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              class="h-tableInput"/>
                                    <dictname v-else category="shifou_keyong"  :v="scope.row.doApproval"
                                              :class="[(scope.row.color == 2)?'yhtabRed':(scope.row.color == 3)?'yhtabOrange':(scope.row.color == 4)?'yhtabYellow':(scope.row.color == 5)?'yhtabPink':'']"
                                              style="display:inline-block;width: 100%;height:100%;"/>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column v-if="showColor" prop="color">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                v-if="show"
                                width="100">
                            <template slot-scope="scope">
                               <el-button v-if="scope.row.color == 2 && scope.row.status == 1"
                                           @click="handleClickdel(scope.$index, tableData, scope.row)" type="text">删除
                                </el-button>
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-delete" v-if="scope.row.color == 2 && scope.row.status == 1" title="删除" @click="handleClickdel(scope.$index, tableData, scope.row)"></span>
								</div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL" v-if="showDao">
                    <el-button style="margin-right: 0.2rem;" class="h-btn h-formBtn h-bgblueQ"
                               icon="h-el-icon h-el-icon-export"
                               @click="uploaddownexcelflagbtn">批量导入
                    </el-button>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="xinXiLoudImportExcel"
                                     :startrow="4" :extparams="bd" @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-tableBL" :style="{marginLeft:(showDao==true?'0.2rem':'')}">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">
                        批量导出
                    </el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="handleFilter"/>
                </div>
            </div>
        </div>
        <div class="h-txtCenter h-mrt60" style="margin: 1rem auto 0 auto;">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>
            <el-button v-if="showAn" class="h-btn h-bBtn h-bggreen" @click="saveTo">保存</el-button>
            <el-button v-if="showAn" class="h-btn h-bBtn h-bgblueQ2" @click="subTo">提交</el-button>
        </div>
    </div>
</template>
<script>

    import big from 'big.js'
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        name: 'leftMenu',
        data() {
            return {
				
                // shifoukeyonglist:[],
                showColor: false,
                uploaddownexcelflag: false,
                showArea: false,
                showDao: true,
                showAn: true,
                a: '',
                formInline: {
                    cdate: this.getYMDDate(),
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                userRole: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                show: false,
                moreCondition: false
            }
        },
        mounted() {

        },
        created() {
			// 遮罩
			this.showzhezhao()
            // this.shifoukeyonglist = this.$store.getters.dictlist("shifou_keyong");
            this.query();
        },
        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            //明细导出
            exportExcel() {
                var idlist = [];
                this.tableData.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/bscLoud/downloadExcel", idlist, "post", 'data');
            },
            getYMDDate() {
                const now = new Date()
                return [now.getFullYear(),
                    now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1,
                    now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
                ].join('-');
            },
            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                }
            },
            tablemouseenter(row) {
                if (row.color == 2 && row.status == 1) {
                    this.show = true;
                }
            },
            tablemouseleave() {
                this.show = false;
            },
            handleClickdel(index, rows, v) {
                this.$msg.confirm("确认删除?", () => {
                    rows.splice(index, 1);
                    ss.loud.deleteRow(v).then(rd => {
                        this.$msg.msgs(rd.msg);
                    })
                })
            },
            uploadExcelFilecallback() {
                this.query();
            },
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            query() {
                this.userRole = this._user.roles;
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_admin" || item.id == "swyl_guanhgly") {
                        this.showArea = true;
                        this.showAn = false;
                        this.showDao = false;
                        this.a = 1;
                        return;
                    } else {
                        if (item.id == "swyl_quyujl") {
                            this.a = 2;
                            return;
                        }
                        if (item.id == "swyl_xiaoshoujl" || item.id == "swyl_xiaoshoujl_shanghai") {
                            this.a = 3;
                            return;
                        }
                    }
                })
                ss.loud.page(this.formInline).then(rd => {
                    // for(var c in rd.records){
                    //     for(var cc in this.shifoukeyonglist){
                    //         if(rd.records[c].doApproval==this.shifoukeyonglist[cc].code){
                    //             rd.records[c].doApprovalname = this.shifoukeyonglist[cc].name;
                    //         }
                    //     }
                    // }
                    this.tableData = rd.records;
                    this.formInline.total = rd.total;
                    this.tableData.forEach((item, index) => {
                        if (item.bidPercentage == "null") {
                            item.bidPercentage = " "
                        }
                    })
                })
            },
            handleFilter() {
                this.formInline.cdate = this.formInline.cdate == '' || this.formInline.cdate == null ? '' : this.$util.riQi(this.formInline.cdate);
                ss.loud.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.tableData.forEach((item, index) => {
                        if (item.bidPercentage == "null") {
                            item.bidPercentage = " "
                        }
                    })
                    // for (var n = 0; n < this.tableData.length - 1; n++) {
                    //     for (var m = 1; m < this.tableData.length; m++) {
                    //         if (this.tableData[n].totalValue && this.tableData[m].totalValue) {
                    //             if (n.productType == m.productType && n.customerName == m.customerName) {
                    //                 this.cha = new big(this.tableData[n].totalValue).minus(this.tableData[m].totalValue);
                    //                 this.cha.abs();
                    //                 this.shu = this.cha.abs().div(this.tableData[n].totalValue);
                    //                 if (this.shu <= 0.1) {
                    //                     this.tableData[n].dede = 2;
                    //                     this.tableData[m].dede = 2;
                    //                 }
                    //             }
                    //         }
                    //     }
                    // }
                })
            },
            resetData() {
                this.formInline.statusR = '';
                this.formInline.cdate = this.getYMDDate();
                this.formInline.expectConvertDate = '';
                this.formInline.area = '';
                this.formInline.productType = '';
                this.formInline.bidConvDate = '';
                this.formInline.expConvDate = '';
                this.formInline.bidPercentage = '';
                this.formInline.chance = '';
                this.formInline.customerChannel = '';
                this.formInline.remark = '';
                this.formInline.dbBrand = '';
                this.formInline.doBudget = '';
                this.formInline.whetherContactor = '';
                this.formInline.doApproval = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.query();
            },
            saveTo() {
                var t = 1;
                if (this.tableData.length == 0) {
                    this.$msg.msge("请不要保存空数据!");
                    t = 2;
                }
                if (t == 1) {
                    ss.loud.saveTo(this.tableData).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    })
                }
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    var t = 1;
                    if (this.tableData.length == 0) {
                        this.$msg.msge("请不要提交空数据!");
                        t = 2;
                    }
                    if (t == 1) {
                        ss.loud.subTo(this.tableData).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        })
                    }
                })
            },
            renovate() {
                this.query();
            },
            
        }
    }
</script>
<style>
    .smTable .el-table tbody td .cell {
        padding-top: 0;
        padding-bottom: 0;
    }

    .el-table thead.is-group th {
        background-color: #57aefe;
    }

    .yh-red .el-input__inner {
        color: red;
    }

    .yhtabRed.h-tableInput .el-input__inner {
        color: red;
    }

    .yhtabOrange.h-tableInput .el-input__inner {
        color: orange;
    }

    .yhtabYellow.h-tableInput .el-input__inner {
        background: yellow;
    }

    .yhtabPink.h-tableInput .el-input__inner {
        color: pink;
    }

    .yhtabPink {
        color: pink;
        height: 76px;
        line-height: 76px;
    }

    .yhtabYellow {
        background: yellow;
        height: 76px;
        line-height: 76px;
    }

    .yhtabOrange {
        color: orange;
        height: 76px;
        line-height: 76px;
    }

    .yhtabRed {
        color: red;
        height: 76px;
        line-height: 76px;
    }
</style>

